const colors = [
  'red',
  'blue',
  'plum',
  'coffee',
  'orange',
  'maroon',
  'rose',
  'flamingo',
  'mandarin',
  'pine',
  'emerald',
  'pink',
  'green',
  'gold',
  'lime',
  'acid',
  'navy',
]

let currentIndex = 0

export const getNextRandomColor = (): string => {
  if (currentIndex >= colors.length) {
    currentIndex = 0
  }
  return colors[currentIndex++]
}

export const resetRandomColors = (): void => {
  currentIndex = 0
}
